import React, { useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";
import { languageHelper } from "../../../../config/helperFunctions";



function LoyaltyPointsReport() {
  const columns = [
    {
      header: languageHelper("SN") || "SN",
      accessorKey: "SN",
    },
    {
      header: languageHelper("Customer Name") || "Customer Name",
      accessorKey: "Customer Name",
    },
    {
      header: languageHelper("Phone") || "Phone",
      accessorKey: "Phone",
    }, {
      header: languageHelper("Earned Points") || "Earned Points",
      accessorKey: "Earned Points",
    }, {
      header: languageHelper("Spent Points") || "Spent Points",
      accessorKey: "Spent Points",
    }, {
      header: languageHelper("Earned Points") || "Earned Points",
      accessorKey: "Earned Points",
    },
  ];
  const [data] = useState([]);

  return (
    <main className="my-16">
      <div className="text-d-bg-text text-3xl text-center my-4">
      {languageHelper("Loyalty Points Report")}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default LoyaltyPointsReport
;

